import React, {PropsWithChildren} from "react";
import {Tooltip, VariantType, PlacesType} from 'react-tooltip';
import classNames from "classnames";


type IReactTooltipProps = {
    selectId: string;
    additionalClasses?: string;
    variant?: VariantType;
    delay?: number;
    clickable?: boolean;
    hidden?: boolean;
    openOnClick?: boolean;
    isTransparent?: boolean;
    place?: PlacesType;
}

export const ReactTooltip = ({children, selectId, variant = "light", delay = 300, place, clickable = true, hidden=false, openOnClick = false, additionalClasses, isTransparent}: PropsWithChildren<IReactTooltipProps>) => {
    return (
        <Tooltip
            style={{"--rt-opacity": isTransparent ? 0.90 : 1} as React.CSSProperties}
            className={classNames("image-tooltip-override  text-center", additionalClasses)}
            classNameArrow={"arrow-classes"}
            openOnClick={openOnClick}
            anchorSelect={`#${selectId}`}
            variant={variant}
            place={place}
            hidden={hidden}
            delayShow={delay}
            clickable={clickable}>
            {children}
        </Tooltip>
    );
}
